<div class="card">

  <div class="card-header ais-color d-flex flex-row justify-content-between"
       title="{{title}}"
       (click)="headerClick()">
    <div class="h6 title">{{title}}</div>

      <button i18n-title title="Ďalšie informácie, položky štúdia"
              mat-mini-fab color="warn"
              [matMenuTriggerFor]="extra"
              (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #extra="matMenu">
          <button mat-menu-item i18n (click)="openMobilityApp()">Mobility</button>
          <button mat-menu-item i18n (click)="openSkolnePoplatkyApp()">Školné a poplatky</button>
          <button mat-menu-item i18n (click)="openStipendiaApp()">Štipendiá</button>
          <button mat-menu-item i18n (click)="openUdelovanieSuhlasovApp()">Udeľovanie súhlasov</button>
          <button mat-menu-item [matMenuTriggerFor]="kontroly" i18n>Kontroly</button>
      </mat-menu>

      <mat-menu #kontroly="matMenu">
          <button mat-menu-item i18n (click)="openKomplexnaKontrolaApp()">Komplexná kontrola</button>
          <button mat-menu-item i18n (click)="openPovinnePredmetyApp()">Povinné predmety</button>
          <button mat-menu-item i18n (click)="openNeuspesneZapisyApp()">Neúspešné zápisy predmetov</button>
          <button mat-menu-item i18n (click)="openAbsolvovaniePredmetovApp()">Absolvovanie predmetov</button>
          <button mat-menu-item i18n (click)="openZiskaneKredityApp()">Získané kredity</button>
          <button mat-menu-item i18n (click)="openPredpisanaSkladbaApp()">Predpísaná skladba</button>
      </mat-menu>

  </div>

  <div class="card-body small" *ngIf="show">
    <app-zapisne-listy [studium]="data"></app-zapisne-listy>
    <app-zaverecne-prace [zaverecnePrace]="data.zaverecnePrace" [studium]="data"></app-zaverecne-prace>
    <app-statne-skusky [data]="data.statneSkusky" [studium]="data"></app-statne-skusky>
    <app-slavnosti [data]="data.slavnosti" [studium]="data"></app-slavnosti>
  </div>

</div>
